
import Vue from "vue"

export default Vue.extend({
  name: "EventsDivisionsSchedulerDivisionSelectItem",
  props: {
    division: { type: Object, required: true }
  }
})
